<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{ "admin.dialogs.edit" | translate }} {{data.code}}</h2>
  <mat-card-content>
    <form (submit)="sendEditionRequest()" [formGroup]="dialogEditForm">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <mat-label>{{ "admin.dialogs.title" | translate }}</mat-label>
          <input [formControl]="titleControl" matInput type="text">
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>{{ "admin.dialogs.description" | translate }}</mat-label>
          <textarea [formControl]="descriptionControl" matInput type="text"></textarea>
        </mat-form-field>
        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button mat-raised-button color="primary" type="submit" [disabled]="dialogEditForm.invalid">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
